<div class="grid-ui-error-box" [class.mc-full]="size === 'full'" [class.mc-reduced]="size === 'reduced'">
  <div class="mc-left-container">
    @if (errorCode) {
      <h1>
        <span>{{ errorCode }}</span>
      </h1>
    }
    @if (!errorCode) {
      <h1><span>Sorry</span></h1>
    }
  </div>
  <div class="mc-right-container">
    <div>
      @if (errorCode) {
        <p>Sorry, something went wrong.</p>
      }
      @if (!errorCode) {
        <p>Something went wrong.</p>
      }
      @if (showContact && contactEmail) {
        <p>
          If you continue to encounter this problem, please contact
          <a href="mailto:{{ contactEmail }}" data-testid="link-support-email">{{ contactEmail }}</a>
        </p>
      }
    </div>
    @if (errorMessage) {
      <div>
        <p class="caption">
          {{ errorMessage }}
        </p>
      </div>
    }
    <div class="buttons">
      @if (errorPrimaryAction?.length > 0) {
        <button
          data-hook="primary-button"
          class="btn mc-btn-primary"
          (click)="triggerPrimaryAction($event)"
          [attr.data-testid]="'btn-' + errorPrimaryAction | slugify"
        >
          {{ errorPrimaryAction! | uppercase }}
        </button>
      }
      @if (errorSecondaryAction?.length > 0) {
        <button
          data-hook="secondary-button"
          class="btn mc-btn-secondary"
          (click)="triggerSecondaryAction($event)"
          [attr.data-testid]="'btn-' + errorSecondaryAction | slugify"
        >
          {{ errorSecondaryAction! | uppercase }}
        </button>
      }
    </div>
  </div>
</div>
